import { Icon, IconName } from '@/components/Icon';
import { IconRotate, IconSize } from '@/components/Icon/types';
import styles from '@/components/Loading/CustomLoading.module.css';

export interface CustomLoadingProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  leadingIcon?: IconName;
  leadingIconDirection?: IconRotate;
  iconClassName?: string;
}

export const CustomLoading = ({
  size = 'medium',
  message,
  leadingIcon,
  leadingIconDirection,
  iconClassName = '',
}: CustomLoadingProps) => {
  const sizeConfig = {
    small: { spinner: 80, buttonHeight: 'var(--height-sm)', fontSize: 'var(--font-size-xs)', minWidth: '90px' },
    medium: { spinner: 130, buttonHeight: 'var(--height-md)', fontSize: 'var(--font-size-sm)', minWidth: '130px' },
    large: { spinner: 200, buttonHeight: 'var(--height-lg)', fontSize: 'var(--font-size-md)', minWidth: '200px' },
  };

  const currentSize = sizeConfig[size];

  return (
    <div
      className={styles.spinnerContainer}
      style={{ width: `${currentSize.spinner}px`, height: `${currentSize.spinner}px` }}>
      <svg
        fill='none'
        height={currentSize.spinner}
        viewBox='0 0 130 130'
        width={currentSize.spinner}
        xmlns='http://www.w3.org/2000/svg'>
        <circle
          className={styles.inner}
          cx='65'
          cy='65'
          r='32'
          strokeDasharray='0.1 18.25'
          strokeLinecap='round'
          strokeWidth='6'
        />
        <circle
          className={styles.middle}
          cx='65'
          cy='65'
          r='48'
          strokeDasharray='0.1 17.75'
          strokeLinecap='round'
          strokeWidth='4'
        />
        <circle
          className={styles.outer}
          cx='65'
          cy='65'
          r='64'
          strokeDasharray='0.1 16'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
      <div
        className={styles.overlayButton}
        style={{
          height: currentSize.buttonHeight,
          fontSize: currentSize.fontSize,
          minWidth: currentSize.minWidth,
        }}>
        {leadingIcon && (
          <Icon className={iconClassName} direction={leadingIconDirection} name={leadingIcon} size={IconSize.medium} />
        )}
        <span className={styles.buttonText}>{message}</span>
      </div>
    </div>
  );
};

// interface CustomLoadingProps {
//   size?: 'small' | 'medium' | 'large';
//   message: string;
//   leadingIcon?: IconName;
//   leadingIconDirection?: IconRotate;
// }

// export const CustomLoading = ({ size = 'medium', message, leadingIcon, leadingIconDirection }: CustomLoadingProps) => {
//   const iconSizesSwitch = {
//     small: IconSize.extraSmall,
//     medium: IconSize.medium,
//     large: IconSize.large,
//   };

//   return (
//     <div className={styles.spinnerContainer}>
//       <svg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130' fill='none'>
//         <circle
//           className={styles.inner}
//           cx='65'
//           cy='65'
//           r='32'
//           strokeWidth='6'
//           strokeLinecap='round'
//           strokeDasharray='0.1 18.25'
//         />
//         <circle
//           className={styles.middle}
//           cx='65'
//           cy='65'
//           r='48'
//           strokeWidth='4'
//           strokeLinecap='round'
//           strokeDasharray='0.1 17.75'
//         />
//         <circle
//           className={styles.outer}
//           cx='65'
//           cy='65'
//           r='64'
//           strokeWidth='2'
//           strokeLinecap='round'
//           strokeDasharray='0.1 16'
//         />
//       </svg>
//       <div className={styles.overlayButton}>
//         {leadingIcon && <Icon name={leadingIcon} direction={leadingIconDirection} size={iconSizesSwitch[size]} />}
//         <span className={styles.buttonText}>{message}</span>
//       </div>
//     </div>
//   );
// };
